import styled from 'styled-components';

type ICardBody = {
  disabled?: boolean;
};

const CardContainer = styled.button`
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;

  .headerTitle {
    padding-left: 8px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: ${(props) => (props.disabled ? '#000000' : '#1a055d')};
  }

  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: self-start;
    text-align: left;
  }

  p {
    padding-left: 8px;
    color: #161d1f;
  }

  &:hover {
    cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
    background: ${(props) => (props.disabled ? '#ffffff' : '#d5e5f0')};
  }

  &:focus {
    background: ${(props) => (props.disabled ? '#ffffff' : '#a8cbe2')};
  }

  &:active {
    background: ${(props) => (props.disabled ? '#ffffff' : '#a8cbe2')};
  }

  @media (max-width: 991px) {
    width: 100%;
  }

  @media (min-width: 992px) and (max-width: 1279px) {
    width: 340px;
  }
  @media (min-width: 1280px) {
    width: 364px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

const CardBody = styled.div<ICardBody>`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
  color: ${(props) => (props.disabled ? '#8090BB' : '#161d1f')};

  img {
    padding-right: 4px;
  }
`;

export { CardContainer, CardHeader, CardBody };

/*
  .headerTitle {
    padding-left: 8px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: ${(props) => (props.disabled ? '#8090BB' : '#1a055d')};
  }
*/
